module.exports = __webpack_public_path__ + "static/media/notes.c65c4bff.png";